import React from 'react';
import LabelQuestion from './LabelQuestion';
import PhoneInput from './PhoneInput';
import styled from '@emotion/styled';

const IconWrap = styled('div')`
  position: absolute;
  bottom: 8px;
  right: 20px;
  i {
    font-size: 14px;
    opacity: 0.5;
  }
`;

const InputWrapper = (props) => {
  const {
    label,
    noLabel = false,
    id,
    error,
    inputClassName,
    labelClassName,
    showValidation,
    labelStyle = {},
    textAppend,
    component,
    componentProps = {},
    value,
    readOnly = false,
    addButton = false,
    addButtonText = 'Добавить',
    onAddButtonClick = () => false,
    labelQuestion,
    testId,
    //Внимание! При isPhoneInput == true меняется смысл onChange. Параметром в обработчик прилетает не event, а значение. Например:
    //onChange={value => setFieldValue('rawPhone', value)}
    isPhoneInput,
    isDisabled,
    icon,
    iconWrapper,
    iconId,
    onIconClick = () => false,
    autocomplete = 'on',
  } = props;

  let className = inputClassName ? `${inputClassName} ` : 'form-control ';
  let labelClass = labelClassName ? labelClassName : '';

  //const [phoneValue, setPhoneValue] =

  if (showValidation) {
    className += error ? 'is-invalid ' : '';
  }

  if (readOnly) {
    className += 'read-only ';
  }

  const Component = component;

  const passedProps = Object.assign({}, props, { value: value === null ? '' : value });
  delete passedProps.showValidation;
  delete passedProps.component;
  delete passedProps.inputClassName;
  delete passedProps.labelClassName;
  delete passedProps.labelStyle;
  delete passedProps.noLabel;
  delete passedProps.canCopy;
  delete passedProps.componentProps;
  delete passedProps.isPhoneInput;
  delete passedProps.testId;

  let input;
  if (component) {
    input = (
      <Component
        className={className}
        type="text"
        {...passedProps}
        {...componentProps}
        data-testid={testId}
      />
    );
  } else {
    input = isPhoneInput ? (
      <PhoneInput
        className={className}
        showValidation={showValidation && error}
        {...passedProps}
        data-testid={testId}
        specialLabel={false}
      />
    ) : (
      <input
        className={className}
        type="text"
        {...passedProps}
        data-testid={testId}
        disabled={isDisabled}
        autoComplete={autocomplete}
      />
    );
  }

  return (
    <React.Fragment>
      {!noLabel || addButton ? (
        <div style={{ display: 'flex' }}>
          {!noLabel ? (
            <LabelQuestion
              label={label}
              labelClass={labelClass}
              htmlFor={id}
              style={labelStyle}
              question={labelQuestion}
            />
          ) : null}
          {addButton ? (
            <div
              style={{ marginLeft: 'auto', color: '#7e57c2', cursor: 'pointer' }}
              onClick={onAddButtonClick}
              data-testid="addButton"
            >
              + {addButtonText}
            </div>
          ) : null}
        </div>
      ) : null}
      {textAppend ? (
        <div className="input-group">
          {input}
          {icon && (
            <IconWrap className={iconWrapper}>
              <i data-id={iconId} className={icon} onClick={(e) => onIconClick(e)}></i>
            </IconWrap>
          )}
          <div className="input-group-append">
            <span className="input-group-text">{textAppend}</span>
          </div>
        </div>
      ) : (
        <>
          {input}
          {icon && (
            <IconWrap className={iconWrapper}>
              <i data-id={iconId} className={icon} onClick={(e) => onIconClick(e)}></i>
            </IconWrap>
          )}
        </>
      )}

      {error && (
        <div
          className="invalid-feedback invalid-feedback__not-empty"
          data-testid={`${testId}--error`}
        >
          {error}
        </div>
      )}
    </React.Fragment>
  );
};

export default InputWrapper;
